$(function() {
    'use strict';

    var shareBlock = $('.social-share');
    if (!shareBlock.length) return;

    var tmpLink = shareBlock.data('link');
    if (tmpLink.indexOf('//') == -1) {
        if (!window.location.origin) { // IE8 fix
            window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
        }
        tmpLink = window.location.origin + tmpLink;
    }

    var rawLink = tmpLink,
        link = encodeURIComponent(tmpLink),
        image = encodeURIComponent(shareBlock.data('image')),
        title = encodeURIComponent(shareBlock.data('title')),
        text = encodeURIComponent(shareBlock.data('text'));

    var services = {
        ok: {
            popupParams: 'width=550,height=360',
            shareUrl: 'https://connect.ok.ru/offer' +
                '?url=' + link +
                '&title=' + title +
                '&imageUrl=' + image,
            count: function() {
                var deferred = $.Deferred();
                if (!window.ODKL) window.ODKL = {};
                window.ODKL.updateCount = function(idx, number) { deferred.resolve(number) };
                $.ajax({
                    dataType: "jsonp",
                    url: 'https://connect.ok.ru/dk?st.cmd=extLike&uid=0&ref=' + link,
                    type: 'GET',
                    error: function() { deferred.resolve(0) }
                });
                return deferred.promise();
            }
        },
        vk: {
            popupParams: 'width=550,height=330',
            shareUrl: 'https://vk.com/share.php' +
                        '?url=' + link +
                        '&title=' + title +
                        '&image=' + image +
                        '&description=' + text,
            count: function() {
                var deferred = $.Deferred();
                if (!window.VK) window.VK = {};
                window.VK.Share = {
                    count: function(idx, number) { deferred.resolve(number); }
                };
                $.ajax({
                    dataType: "jsonp",
                    url: 'https://vk.com/share.php?act=count&index=0&url=' + link,
                    type: 'GET',
                    error: function() { deferred.resolve(0) }
                });
                return deferred.promise();
            }
        },
        wp: {
            popupParams: 'width=550,height=350',
            shareUrl: 'https://api.whatsapp.com/send?text=' + title + ' ' + link
        },
        telegram: {
            popupParams: 'width=550,height=350',
            shareUrl: 'https://t.me/share/url' + '?url=' + link + '&text=' + title
        }
    };

    function createCountElement(count) {
        return $('<span class="social-share__link-count">' + count + '</span>');
    }

    function openSharePopup($button, service) {
        var popup = window.open(service.shareUrl, '', 'toolbar=0,status=0,width=626,' + service.popupParams);
        var timer = setInterval(function() {
            if(popup.closed) {
                clearInterval(timer);

                if (!service.count) {
                    return;
                }

                service.count().then(function(resp) {
                    var count = parseInt(resp);
                    if (count > 0) {
                        var $link = $button.find('.social-share__link-count');
                        if ($link.length < 1) {
                            $button.append(createCountElement(count));
                        } else {
                            $link.text(count);
                        }
                    }
                });
            }
        }, 1000);
    }

    function createShareButtonElement(name) {
        return $('<a class="social-share__link social-share__link_' + name + '">'
            + '<span class="social-share__link-icon"></span>' + '</a>'
        );
    }

    function copyLink(event) {
        event.preventDefault();
        navigator.clipboard.writeText(rawLink);
    }

    $.each(services, function(name, service) {
        var $button = createShareButtonElement(name);
        $button = $button.appendTo(shareBlock);

        $button.on('click', openSharePopup.bind(null, $button, service));

        if (service.count) {
            service.count().then(function (resp) {
                var count = parseInt(resp);
                if (count > 0) {
                    $button.append(createCountElement(count));
                }
            });
        }
    });

    // Special copy btn, do only for modern browsers
    if (navigator.clipboard !== undefined) {
        var $copyButton = createShareButtonElement('copy');
        $copyButton = $copyButton.appendTo(shareBlock);
        $copyButton.on('click', copyLink);
    }
});
